import React, { Component } from "react";
import { delay, getQueryParam } from "../../../managers/common/CommonUtil";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import Stepper from "../../common/Stepper";
import { importOptions } from "../../import_export/EximConstants";
import EmployeeImportManager from "../employee_import_manager/EmployeeImportManager";
import {
    DKLabel,
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
    showAlert
} from "deskera-ui-library";
import ImportService from "../../import_export/service/Import";
import { convertToCSV, getImportRecords } from "../../import_export/utility/ImportUtility";
import Utility from "../../../utility/Utility";
import { async } from "rxjs";

class ImportEmployeePortal extends Component {
    constructor(props) {
        super(props);
        this.tableName = getQueryParam(this.props.location, "module");
        this.source = getQueryParam(this.props.location, "origin");
        this.steps = EmployeeImportManager.getAllCreationSteps(this.onSkipToStep);
        this.state = {
            currentStep: 0,
            auditLogId: "",
            fileInfo: null,
            fileContent: null,
            mappedHeaders: null,
            importRecords: null,
            invalidRows: null,
            selectedSegmentId: [],
            importProperties: JSON.parse(importOptions),
        };
    }

    componentDidMount() {
        RouteManager.setPresenter(this);

        /* TableName Query Param is required to proceed */
        if (!this.tableName) {
            RouteManager.navigateToPage(this.source || "/");
        }
    }

    onSkipToStep = async(event, index) => {
        const { currentStep } = this.state;

        /* By default expected step is to move forward */
        const expectedStep = index ?? currentStep + 1;
        if(currentStep === 2) {
            await delay(500);
        }
        /* If it's the last step */
        if (expectedStep === this.steps.length) {
            if (this.state.invalidRows && this.state.invalidRows.length) {
                showToast(this.steps[currentStep].reqError, TOAST_TYPE.FAILURE);
            } else {
                this.handleImportConfirmation();
            }
            return;
        }

        if (this.isInvalidStep(expectedStep)) {
            const errorInfo =
                this.steps[currentStep].reqError ||
                `Sorry can't proceed, please complete the current step first`;
            showToast(errorInfo, TOAST_TYPE.FAILURE);
        } else {
            this.setState({ currentStep: expectedStep });
        }
    };

    handleStepData = (data, callback) => {
        this.setState({ ...data }, callback);
    };

    handleImportConfirmation() {
        let fileName = this.state.fileInfo.name;
        fileName = fileName.replace(/\.[^/.]+$/, "") + ".csv";

        const importRecords = getImportRecords(this.state.importRecords, this.state.mappedHeaders);
        const csvFile = new File([convertToCSV(importRecords)], fileName);

        showLoader("Processing... Please wait");
        EmployeeImportManager.getUploadFileRelativeURL(csvFile).then(
            (filePath) => {
                const payload = {
                    dataInsight: {
                        dateFormat: ""
                    },
                    mapping: this.state.mapping.map((header) => {
                        return {
                            colHeader: header.colHeader,
                            displayName: header.displayName,
                            fieldName: header.fieldName,
                            customField: header.customField,
                            customFieldConfig: header.customFieldConfig,
                        }
                    })
                }
        
                const queryParam = {
                    module: "PEOPLE_USER",
                    relativeFilePath: filePath,
                    auditLogId: this.state.auditLogId
                }
        
                ImportService.import(payload, queryParam).then(
                    (response) => {
                        removeLoader();
                        this.showImportMessage(response);
                    }, (error) => {
                        removeLoader();
                        showToast("Something went wrong while importing records.", TOAST_TYPE.FAILURE);
                    }
                );
            }
        );
    }

    showImportMessage(data) {
        if (data["success"] && Array.isArray(data["success"]) && data["success"].length) {
            if (data["invalid_records"].length) {
                showToast(`Successful Import: ${data["success"].length}, Rejected Records: ${data['invalid_records'].length}.`, TOAST_TYPE.SUCCESS);
            } else {
                showToast("Employee(s) added/updated successfully.", TOAST_TYPE.SUCCESS);
            }
            RouteManager.navigateToPage(this.source);
        } else if (data["Bulk_Import"]) {
            showToast("Import is in progress, we will notify you once done.", TOAST_TYPE.SUCCESS);
            RouteManager.navigateToPage(this.source);
        } else if(data && data["Plan limit exceed"] && !Utility.isEmpty(data["Plan limit exceed"])){
            const deleteConfirm = [
                {
                    title: "Ok",
                    className: "bg-app text-white border-m",
                    onClick:((e) =>
                    this.onSkipToStep(e, 0)
                    )
                }
            ];
            showAlert(
                "Plan upgrade!!",
                data["Plan limit exceed"],
                deleteConfirm
            )
        } else {
            showToast("Import Unsuccessful, some or all employees were not imported properly.", TOAST_TYPE.FAILURE);
            RouteManager.navigateToPage(this.source);
        }

        
    }

    getCurrentStepChild() {
        const currStep = this.steps[this.state.currentStep];
        return currStep.getChild({
            state: this.state,
            tableName: this.tableName,
            setData: this.handleStepData,
        });
    }

    isInvalidStep = (expectedStep) => {
        if (expectedStep < 0 || expectedStep >= this.steps.length) return false;

        /* Check if component has required data for expected step */
        const { requiredProps } = this.steps[expectedStep];
        return requiredProps.some(
            (requiredProp) => this.state[requiredProp] === null
        );
    };

    navigateToPage() {
        RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_LIST)
    }

    getControllers() {
        const { fileInfo, currentStep } = this.state;
        const isLastStep = currentStep === this.steps.length - 1;
        return (
            <div className="row parent-width justify-content-center mb-l">
                {
                    <DKButton
                        title="Cancel"
                        className="border-m ml-r bg-white"
                        onClick={(e) => this.navigateToPage()}
                    />
                }
                {currentStep !== 0 && (
                    <DKButton
                        title="Back"
                        className="border-m ml-r bg-white"
                        onClick={(e) => this.onSkipToStep(e, currentStep - 1)}
                    />
                )}
                {fileInfo && (
                    <DKButton
                        title={!isLastStep ? "Continue" : "Save"}
                        className="border-m ml-r bg-app text-white"
                        onClick={this.onSkipToStep}
                    />
                )}
            </div>
        );
    }

    render() {
        return (
            <>
                <div className="column parent-width">
                    <DKLabel text="Import Employee" className="fw-m fs-l mb-r" />
                    <Stepper
                        data={this.steps}
                        currentIndex={this.state.currentStep}
                        className="mb-l"
                    />

                    <div className="row parent-width m-v-xl justify-content-center">
                        {this.getCurrentStepChild()}
                    </div>

                    {this.getControllers()}
                </div>
            </>
        );
    }
}

export default ImportEmployeePortal;
